// extracted by css-extract-rspack-plugin
export default {"squareBanner":"IpmBannerBase-module__squareBanner__LXt3H","hiddenLeadingVisual":"IpmBannerBase-module__hiddenLeadingVisual__cJ9ZZ"};